<div class="status-container">
  <avn-icon *ngIf="showStatusIcon" [fontSize]="20" [icon]="icon" [avnTheme]="iconTheme"> </avn-icon>
  <span>{{ message || syncProgress.status }}</span>
</div>
